import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Typography, Box } from '@mui/material';
import { SelectField } from 'components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { enqueueSnackbar } from 'actions';
import { SetFormState, ToggleOptionsSiteTrackerForm, AddDropdownField, RemoveDropdownField } from '../../../../actions/SiteTrackerActions';

const SiteTrackerOptionsForm = (props) => {
	const { open, dropdownLabel, dropdownName, dropdownValue, dropdownId, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.siteTrackerReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.siteTrackerReducer.formState);
	const dropdowns = useSelector(state => state.siteTrackerReducer.dropdowns);

	const [dropdownValueAdded, setdropdownValueAdded] = useState('');

	const _handleChange = (event) => {
		setdropdownValueAdded(event.target.value);
	};

	const _handleClose = () => {
		dispatch(ToggleOptionsSiteTrackerForm(false));
	};

	const relations = { levelOneId: formState.values.levelOne, levelTwoId: formState.values.levelTwo, levelThreeId: formState.values.levelThree };

	const _handleAdd = () => {
		dispatch(AddDropdownField(userId, dropdownName, dropdownValueAdded, relations));
		dispatch(ToggleOptionsSiteTrackerForm(false));
	};

	const _handleRemove = () => {
		dispatch(RemoveDropdownField(userId, dropdownName, dropdownValue, dropdownId, relations));
		dispatch(ToggleOptionsSiteTrackerForm(false));
		setFormState({
			...formState,
			values: {
				...formState.values,
				[dropdownName]: undefined
			}
		});
	};

	const [expanded, setExpanded] = useState(false);

	return (
		<div>
			<Dialog open={open} onClose={_handleClose}>
				<DialogTitle>{dropdownLabel}</DialogTitle>
				<DialogContent>
					<Box
						component="form"
						sx={{
							'& > :not(style)': { m: 1, width: '25ch' },
						}}
						noValidate
						autoComplete="off"
					>
						<Grid hidden={dropdownId !== undefined}>
							<TextField
								id="outlined-basic"
								name={dropdownLabel}
								label={dropdownLabel}
								variant="outlined"
								onChange={_handleChange}
							/>
						</Grid>
						<Grid hidden={dropdownId === undefined}>
							<Typography variant="h6">
								{`Are you sure you want to delete [${dropdownLabel}] - ${dropdownValue}?`}
							</Typography>
						</Grid>
					</Box>
				</DialogContent>
				<DialogActions>
					<Grid hidden={dropdownId !== undefined}>
						<Button onClick={_handleClose}>Close</Button>
						<Button onClick={_handleAdd}>Add</Button>
					</Grid>
					<Grid hidden={dropdownId === undefined}>
						<Button onClick={_handleClose}>Cancel</Button>
						<Button onClick={_handleRemove}>Remove</Button>
					</Grid>
				</DialogActions>
			</Dialog>
		</div>
	);
};

SiteTrackerOptionsForm.propTypes = {
	open: PropTypes.bool,
	dropdownLabel: PropTypes.string.isRequired,
	dropdownName: PropTypes.string.isRequired,
	dropdownValue: PropTypes.string,
	dropdownId: PropTypes.string
};

export default SiteTrackerOptionsForm;
